/* ============================================================
   NEUTROS — theme.js (Shopify)
   Oversat 1:1 fra demoens app-js, tilpasset Shopify:
   · Ægte kurv (Cart API: /cart.js, /cart/add.js, /cart/change.js)
   · Priser/bundles/tilbud læses fra tema-indstillingerne
     (Theme settings → Prices & bundles)
   · Produktets variant "1 pose" / "2 poser" / "3 poser" bruges
     automatisk, når det er oprettet i Shopify
   · "Udsolgt"-tilstand når lageret er 0
   ============================================================ */
(function () {
  "use strict";

  /* ------- INDSTILLINGER (fra Shopify admin) ------- */
  var S = window.NEUTROS_SETTINGS || {};
  var ROOT = S.root || "";
  var CHECKOUT = S.checkout || "/checkout";
  var PRODUCT_HANDLE = S.productHandle || "neutros";

  /* ------- BILLEDER (let at bytte om — bare sig til!) ------- */
  var CDN = "https://cdn.shopify.com/s/files/1/0963/1809/5687/files/";
  var IMG = {
    pouchMain:   CDN + "Skaermbillede_2026-07-04_kl._11.27.31.png?width=1100",
    renderA:     CDN + "ChatGPT_Image_4._jul._2026_11.16.27.png?width=1100",
    renderB:     CDN + "ChatGPT_Image_4._jul._2026_11.26.46_1.png?width=1100",
    renderC:     CDN + "ChatGPT_Image_4._jul._2026_11.37.53.png?width=1100",
    pouchClear:  CDN + "ChatGPT_Image_5._jul._2026_22.21.50.png?width=1448",
    pouchCrop:   CDN + "ChatGPT_Image_5._jul._2026_22.03.59_e28327c3-c9a0-4e22-9a93-fe0f374390d1.png?width=1448",
    greenPowder: CDN + "Skaermbillede_2026-07-06_kl._15.22.50.png?width=900",
    pinkPowder:  CDN + "ChatGPT_Image_6._jul._2026_15.43.08.png?width=900",
    tanPowder:   CDN + "ChatGPT_Image_6._jul._2026_16.04.23.png?width=900"
  };

  /* ------- PRISER / BUNDLES (fra tema-indstillingerne) ------- */
  var FREE_SHIP = S.freeShip || 199;
  var BUNDLES = [
    { qty: 1, price: S.p1 || 75,  old: S.p1old || 100 },
    { qty: 2, price: S.p2 || 139, old: S.p2old || 150 },
    { qty: 3, price: S.p3 || 199, old: S.p3old || 225 }
  ];

  /* ------- STATE ------- */
  var lang = localStorage.getItem("nn_lang") || "da";
  var selectedBundle = 0; // default: 1 pose
  var pendingBundle = null;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ================= SPROG ================= */
  function t(key) {
    return (window.I18N[lang] && window.I18N[lang][key]) || key;
  }
  function applyLang() {
    document.documentElement.lang = lang === "da" ? "da" : "en";
    $$("[data-i18n]").forEach(function (el) {
      var k = el.getAttribute("data-i18n");
      if (window.I18N[lang][k] !== undefined) el.textContent = window.I18N[lang][k];
    });
    $$("[data-i18n-html]").forEach(function (el) {
      var k = el.getAttribute("data-i18n-html");
      if (window.I18N[lang][k] !== undefined) el.innerHTML = window.I18N[lang][k];
    });
    $$("[data-i18n-ph]").forEach(function (el) {
      var k = el.getAttribute("data-i18n-ph");
      if (window.I18N[lang][k] !== undefined) el.placeholder = window.I18N[lang][k];
    });
    $$(".lang-btn").forEach(function (b) {
      b.classList.toggle("on", b.getAttribute("data-lang") === lang);
    });
    refreshShipMsg();
  }
  function setLang(l) {
    lang = l;
    localStorage.setItem("nn_lang", l);
    applyLang();
    if (getMember()) renderDash(getMember());
    renderAccount();
  }
  $$(".lang-btn").forEach(function (b) {
    b.addEventListener("click", function () { setLang(b.getAttribute("data-lang")); });
  });

  /* ================= TOAST ================= */
  function toast(msg, icon) {
    var box = $(".toasts");
    if (!box) return;
    var el = document.createElement("div");
    el.className = "toast";
    el.innerHTML = '<span class="tick">' + (icon || "✓") + "</span><span>" + msg + "</span>";
    box.appendChild(el);
    setTimeout(function () {
      el.classList.add("out");
      setTimeout(function () { el.remove(); }, 450);
    }, 2800);
  }

  /* ================= ÆGTE SHOPIFY-KURV (Cart API) ================= */
  var cart = { items: [], total_price: 0, item_count: 0 };
  var productInfo = null; // JSON fra /products/{handle}.js

  function cartUrl(p) { return ROOT + p; }
  function cartQty() {
    return (cart.items || []).reduce(function (s, i) { return s + i.quantity; }, 0);
  }
  function cartTotal() {
    return (cart.items || []).reduce(function (s, i) { return s + (i.final_price || i.price || 0) * i.quantity; }, 0);
  }
  function loadCart(cb) {
    fetch(cartUrl("/cart.js")).then(function (r) { return r.json(); }).then(function (c) {
      cart = c || cart;
      updateCart();
      if (cb) cb();
    }).catch(function () {});
  }
  function updateCart() {
    var el = $(".cart-count");
    if (!el) return;
    var n = cartQty();
    el.textContent = n;
    el.classList.toggle("show", n > 0);
    renderDrawer();
  }
  function shopifyAdd(items) {
    return fetch(cartUrl("/cart/add.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) { var e = new Error("cart-error"); e.status = r.status; throw e; }
      return r.json();
    });
  }
  function shopifyChange(key, quantity) {
    return fetch(cartUrl("/cart/change.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart-error");
      return r.json();
    });
  }
  /* Find den variant, der matcher en bundle (1/2/3 poser) */
  function variantForBundle(b) {
    if (!productInfo || !productInfo.variants || !productInfo.variants.length) return null;
    var vs = productInfo.variants;
    var want = String(b.qty);
    var found = null;
    // 1) præcis titel: "1 pose" / "1 poser" / "2 poser" / "3 poser"
    vs.forEach(function (v) {
      var vt = String(v.title || "").trim().toLowerCase();
      if (!found && (vt === want + " pose" || vt === want + " poser")) found = v;
    });
    if (found) return found;
    // 2) titel starter med tallet
    vs.forEach(function (v) {
      if (!found && String(v.title || "").trim().toLowerCase().indexOf(want) === 0) found = v;
    });
    if (found) return found;
    // 3) 3+ varianter → sorter efter pris, tag indeks (qty-1)
    if (vs.length >= 3) {
      var sorted = vs.slice().sort(function (a, b) { return (a.price || 0) - (b.price || 0); });
      var idx = Math.min(b.qty - 1, sorted.length - 1);
      if (sorted[idx]) return sorted[idx];
    }
    return null;
  }
  function setSoldOut() {
    var btn = $(".btn-add");
    var pn = $(".price-now");
    var sb = $(".sb-btn");
    if (btn) { btn.disabled = true; btn.innerHTML = t("prod.soldOut"); }
    if (pn) pn.textContent = t("prod.soldOut");
    if (sb) { sb.disabled = true; sb.textContent = t("prod.soldOut"); }
  }
  function loadProduct() {
    if (!PRODUCT_HANDLE) return;
    fetch(cartUrl("/products/" + PRODUCT_HANDLE + ".js")).then(function (r) {
      return r.json();
    }).then(function (p) {
      productInfo = p;
      var any = (p.variants || []).some(function (v) { return v.available; });
      if (!any) setSoldOut();
    }).catch(function () { /* produktet er ikke oprettet endnu → demo-tilstand */ });
  }
  function addToCart(price, label) {
    // Ægte kurv via Shopify Cart API
    var b = BUNDLES[selectedBundle];
    var v = variantForBundle(b);
    var items;
    if (v) {
      // Matchet bundle-variant (fx "2 poser") → én af den variant
      items = [{ id: v.id, quantity: 1 }];
    } else {
      if (!productInfo) {
        toast(t("toast.prodMissing"), "⚠");
        return;
      }
      // Produktet findes, men varianterne passer ikke til bundlerne
      // → brug standard-varianten × antal poser i bundlen
      var dv = (productInfo.variants || []).filter(function (x) { return x.available; })[0];
      if (!dv) { toast(t("toast.prodMissing"), "⚠"); return; }
      items = [{ id: dv.id, quantity: b.qty }];
    }
    shopifyAdd(items).then(function (c) {
      cart = c;
      updateCart();
      toast(t("toast.added") + " — " + label + " · " + formatKr(price));
      var cbtn = $(".cart-btn");
      if (cbtn) { cbtn.style.transform = "scale(1.12)"; setTimeout(function () { cbtn.style.transform = ""; }, 250); }
      openCart();
    }).catch(function () {
      toast(t("toast.cartError"), "⚠");
    });
  }
  function renderDrawer() {
    var items = $(".cd-items");
    if (!items) return;
    var n = cartQty();
    if (n === 0) {
      items.innerHTML = '<div class="cd-empty"><span class="cd-empty-ic">🛒</span>' + t("cd.empty") + "</div>";
    } else {
      items.innerHTML = (cart.items || []).map(function (it) {
        var img = (it.image && it.image.src) ? it.image.src : IMG.pouchMain;
        var name = (it.product_title || "") + (it.variant_title && it.variant_title !== "Default Title" ? " — " + it.variant_title : "");
        return '<div class="cd-item" data-line="' + it.key + '">' +
          '<img src="' + img + '" alt="">' +
          '<div class="ci-info"><div class="ci-name">' + name + '</div><div class="ci-price">' + formatKr((it.final_price || it.price || 0) / 100) + " / stk.</div>" +
          '<div class="cd-qty"><button data-dec aria-label="−">−</button><span>' + it.quantity + '</span><button data-inc aria-label="+">+</button></div></div>' +
          '<div class="ci-line"><span class="ci-line-total">' + formatKr((it.final_price || it.price || 0) / 100 * it.quantity) + '</span><button class="cd-rm" data-rm>' + t("cd.remove") + "</button></div>" +
          "</div>";
      }).join("");
    }
    var totalEl = $(".cd-total-val");
    if (totalEl) totalEl.textContent = formatKr(cartTotal() / 100);
    var pct = Math.min((cartTotal() / 100 / FREE_SHIP) * 100, 100);
    var dbar = $(".cartdrawer .ship-track i");
    var dmsg = $(".cartdrawer .ship-msg");
    if (dbar) dbar.style.width = pct + "%";
    if (dmsg) {
      var total = cartTotal() / 100;
      dmsg.innerHTML = total >= FREE_SHIP ? t("prod.ship.free") : t("prod.ship.almost").replace("{n}", String(Math.ceil(FREE_SHIP - total)));
    }
  }
  function openCart() {
    var d = $(".cartdrawer"), b = $(".cd-backdrop");
    if (d) { d.classList.add("open"); d.setAttribute("aria-hidden", "false"); d.setAttribute("aria-modal", "true"); }
    if (b) b.classList.add("show");
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    var d = $(".cartdrawer"), b = $(".cd-backdrop");
    if (d) { d.classList.remove("open"); d.setAttribute("aria-hidden", "true"); }
    if (b) b.classList.remove("show");
    document.body.style.overflow = "";
  }
  var cartBtn = $(".cart-btn");
  if (cartBtn) cartBtn.addEventListener("click", openCart);
  var cdClose = $(".cd-close");
  if (cdClose) cdClose.addEventListener("click", closeCart);
  var cdBack = $(".cd-backdrop");
  if (cdBack) cdBack.addEventListener("click", closeCart);
  var cdCont = $("[data-continue]");
  if (cdCont) cdCont.addEventListener("click", closeCart);
  var cdCheck = $("[data-checkout]");
  if (cdCheck) cdCheck.addEventListener("click", function () {
    if (cartQty() === 0) { closeCart(); return; }
    window.location.href = CHECKOUT;
  });
  document.addEventListener("click", function (e) {
    var inc = e.target.closest("[data-inc]"), dec = e.target.closest("[data-dec]"), rm = e.target.closest("[data-rm]");
    var itemEl = (inc || dec || rm) ? (inc || dec || rm).closest(".cd-item") : null;
    if (!itemEl) return;
    var key = itemEl.getAttribute("data-line");
    if (!key) return;
    var it = (cart.items || []).filter(function (x) { return x.key === key; })[0];
    if (!it) return;
    var nq;
    if (inc) nq = it.quantity + 1;
    else if (dec) nq = it.quantity - 1;
    else nq = 0;
    shopifyChange(key, Math.max(0, nq)).then(function (c) {
      cart = c;
      updateCart();
    }).catch(function () {});
  });
  function formatKr(n) {
    return n.toLocaleString(lang === "da" ? "da-DK" : "en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + " kr";
  }

  /* ================= ROUTER ================= */
  var ROUTES = {
    "#/": "view-home",
    "#/produkt": "view-product",
    "#/om-os": "view-about",
    "#/katalog": "view-catalog",
    "#/kontakt": "view-contact",
    "#/medlem": "view-member",
    "#/ordrehistorik": "view-orders",
    "#/profil": "view-profile",
    "#/adresser": "view-addresses",
    "#/favoritter": "view-favorites",
    "#/hjaelpecenter": "view-help",
    "#/handelsbetingelser": "view-terms",
    "#/privatlivspolitik": "view-privacy",
    "#/cookiepolitik": "view-cookie",
    "#/sog": "view-search"
  };
  var scrollTarget = null;

  function route() {
    var hash = location.hash || "#/";
    if (!ROUTES[hash]) hash = "#/";
    var activeId = ROUTES[hash];
    var view = document.getElementById(activeId);
    if (!view) view = document.getElementById("view-home");
    $$(".view").forEach(function (v) { v.classList.remove("active"); });
    // Ikke en SPA-side (fx login-/konto-sider uden SPA) → intet at vise
    if (!view) return;
    view.classList.add("active");

    $$(".nav-links a, .mmenu a.m-link, .bmenu a, .mnav a").forEach(function (a) {
      a.classList.toggle("active", a.getAttribute("href") === hash);
    });
    closeMenu();
    // Køb-bjælken vises kun på produktsiden — skjul den ved hvert side-skift
    var sbRoute = $(".stickybar");
    if (sbRoute) sbRoute.classList.remove("show");
    window.scrollTo({ top: 0, behavior: "auto" });

    $$(".reveal", view).forEach(function (el) {
      el.classList.remove("in");
      if (el.hasAttribute("data-count")) el.setAttribute("data-counted", "");
    });
    requestAnimationFrame(function () {
      $$(".reveal", view).forEach(function (el) { io.observe(el); });
      heroTick();
    });

    if (hash === "#/produkt") {
      if (pendingBundle !== null) { selectBundle(pendingBundle); pendingBundle = null; }
    }
    if (hash === "#/medlem") renderClub();
    if (hash === "#/ordrehistorik" || hash === "#/profil" || hash === "#/adresser" || hash === "#/favoritter" || hash === "#/hjaelpecenter") renderAccount();
    requestAnimationFrame(clubFlowers);

    if (scrollTarget) {
      var el = document.querySelector(scrollTarget);
      scrollTarget = null;
      if (el) setTimeout(function () { smoothScrollToEl(el); }, 60);
    }
  }
  window.addEventListener("hashchange", route);

  /* ================= CUSTOM SMOOTH SCROLL ================= */
  // Den indbyggede smooth-scroll (behavior: "smooth") satte sig fast i visse browsere:
  // efter ét programmatisk smooth-scroll kunne man ikke længere scrolle op med musen.
  // Derfor kører vi vores egen bløde animation via requestAnimationFrame — den kan aldrig
  // sætte sig fast, og brugerens hjul/touch afbryder den altid øjeblikkeligt.
  var smoothRaf = null;
  var smoothToken = 0;
  function cancelSmoothScroll() {
    smoothToken++;
    if (smoothRaf) { cancelAnimationFrame(smoothRaf); smoothRaf = null; }
  }
  function smoothScrollTo(targetY) {
    cancelSmoothScroll();
    var myToken = smoothToken;
    var maxY = Math.max(0, (document.documentElement.scrollHeight || document.body.scrollHeight) - window.innerHeight);
    targetY = Math.max(0, Math.min(targetY, maxY));
    var startY = window.scrollY;
    var dist = targetY - startY;
    if (Math.abs(dist) < 1) return;
    var dur = Math.min(1000, Math.max(400, Math.abs(dist) * 0.45));
    var t0 = performance.now();
    function step(ts) {
      if (myToken !== smoothToken) return;
      var p = Math.min((ts - t0) / dur, 1);
      var ease = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      window.scrollTo(0, startY + dist * ease);
      if (p < 1) smoothRaf = requestAnimationFrame(step);
      else smoothRaf = null;
    }
    smoothRaf = requestAnimationFrame(step);
  }
  function smoothScrollToEl(el) {
    if (el) smoothScrollTo(el.getBoundingClientRect().top + window.scrollY);
  }
  window.addEventListener("wheel", cancelSmoothScroll, { passive: true });
  window.addEventListener("touchstart", cancelSmoothScroll, { passive: true });

  document.addEventListener("click", function (e) {
    var sc = e.target.closest("[data-scroll]");
    if (sc) {
      e.preventDefault();
      var href = sc.getAttribute("href") || "#/";
      scrollTarget = sc.getAttribute("data-scroll");
      if (location.hash === href && scrollTarget) {
        var el = document.querySelector(scrollTarget);
        if (el) smoothScrollToEl(el);
      } else {
        location.hash = href;
      }
    }
    var bundleLink = e.target.closest("[data-goto-bundle]");
    if (bundleLink) {
      e.preventDefault();
      pendingBundle = parseInt(bundleLink.getAttribute("data-goto-bundle"), 10) - 1;
      location.hash = "#/produkt";
    }
    var buy = e.target.closest("[data-buy]");
    if (buy) {
      e.preventDefault();
      var pvBuy = $("#view-product");
      if (!pvBuy || !pvBuy.classList.contains("active")) {
        // På alle andre sider end produktsiden → send brugeren til produktsiden
        location.hash = "#/produkt";
      } else {
        var bq = BUNDLES[selectedBundle].qty;
        addToCart(BUNDLES[selectedBundle].price, t("prod.bs" + bq + "q"));
      }
    }
  });

  /* ================= REVEAL (scroll-in) ================= */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        en.target.classList.add("in");
        if (en.target.hasAttribute("data-count") && !en.target.hasAttribute("data-counted")) {
          en.target.setAttribute("data-counted", "");
          countUp(en.target);
        }
        io.unobserve(en.target);
      }
    });
  }, { threshold: 0.14, rootMargin: "0px 0px -6% 0px" });
  $$(".reveal").forEach(function (el) { io.observe(el); });

  function countUp(el) {
    var target = parseFloat(el.getAttribute("data-count"));
    var dec = el.getAttribute("data-dec") ? parseInt(el.getAttribute("data-dec"), 10) : 0;
    var dur = 1400, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(dec).replace(".", lang === "da" ? "," : ".");
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ================= HERO SCROLL ================= */
  var heroCopy = $(".hero-copy"), heroMedia = $(".hero-media");
  function heroTick() {
    // På mobil ingen parallax — teksten skal aldrig forsvinde ved scroll
    if (window.matchMedia("(max-width: 640px)").matches) {
      if (heroCopy) { heroCopy.style.transform = ""; heroCopy.style.opacity = ""; }
      if (heroMedia) { heroMedia.style.transform = ""; }
      return;
    }
    if (!location.hash || location.hash === "#/") {
      var y = window.scrollY;
      var h = Math.max(window.innerHeight, 1);
      var p = Math.min(y / h, 1);
      if (heroCopy) { heroCopy.style.transform = "translateY(" + (p * 70) + "px)"; heroCopy.style.opacity = String(1 - p * 1.25); }
      if (heroMedia) { heroMedia.style.transform = "translateY(" + (p * 46) + "px) scale(" + (1 - p * 0.1) + ")"; }
      $$("[data-plx]").forEach(function (el) {
        var f = parseFloat(el.getAttribute("data-plx")) || 0;
        el.style.translate = "0 " + Math.round(p * 90 * f) + "px";
      });
    }
  }

  /* ================= NAV / SCROLL ================= */
  var nav = $(".nav");
  var totop = $(".totop");
  function onScroll() {
    nav.classList.toggle("scrolled", window.scrollY > 12);
    var sh = $(".site-header");
    if (sh) sh.classList.toggle("scrolled", window.scrollY > 60);
    if (totop) totop.classList.toggle("show", window.scrollY > 750);
    if (!window._heroBusy) { window._heroBusy = true; requestAnimationFrame(function () { heroTick(); window._heroBusy = false; }); }
    clubFlowers();
    var sb = $(".stickybar");
    var buybox = $(".buybox");
    var pv = $("#view-product");
    if (sb) {
      // Kun på produktsiden — ellers skjuler den bunden af siden (politikker osv.)
      if (pv && pv.classList.contains("active") && buybox) {
        var boxTop = buybox.getBoundingClientRect().top;
        sb.classList.toggle("show", boxTop < 40);
      } else {
        sb.classList.remove("show");
      }
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  if (totop) totop.addEventListener("click", function () { smoothScrollTo(0); });

  /* ================= MOBILE MENU + BURGER MENU (alle sider) ================= */
  var mmenu = $(".mmenu");
  var bmenu = $("#bmenu");
  var burger = $(".burger");
  function closeMenu() {
    if (mmenu) mmenu.classList.remove("open");
    if (bmenu) { bmenu.classList.remove("open"); bmenu.setAttribute("aria-hidden", "true"); }
    if (burger) burger.classList.remove("open");
  }
  function toggleBMenu() {
    if (!bmenu) return;
    var open = !bmenu.classList.contains("open");
    if (open) {
      var sh = $(".site-header");
      if (sh && window.innerWidth > 620) bmenu.style.top = (sh.offsetHeight + 12) + "px";
      bmenu.setAttribute("aria-hidden", "false");
    }
    bmenu.classList.toggle("open", open);
    if (burger) burger.classList.toggle("open", open);
  }
  if (burger) burger.addEventListener("click", function (e) { e.stopPropagation(); toggleBMenu(); });
  var bmClose = $("#bmClose");
  if (bmClose) bmClose.addEventListener("click", closeMenu);
  var mclose = $(".m-close");
  if (mclose) mclose.addEventListener("click", closeMenu);
  document.addEventListener("click", function (e) {
    if (bmenu && bmenu.classList.contains("open") && !bmenu.contains(e.target) && !(burger && burger.contains(e.target))) closeMenu();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeMenu(); });

  /* ================= COMPARISON SLIDER (posen / indeni) ================= */
  $$(".cmp").forEach(function (cmp) {
    function setPos(ratio) {
      var pos = Math.max(2, Math.min(98, ratio * 100));
      cmp.style.setProperty("--pos", pos + "%");
    }
    function onMove(x) {
      var r = cmp.getBoundingClientRect();
      setPos((x - r.left) / r.width);
    }
    cmp.addEventListener("pointerdown", function (e) {
      try { cmp.setPointerCapture(e.pointerId); } catch (err) {}
      cmp.classList.add("dragging");
      onMove(e.clientX);
    });
    cmp.addEventListener("pointermove", function (e) {
      if (e.buttons === 1 || cmp.classList.contains("dragging")) onMove(e.clientX);
    });
    ["pointerup", "pointercancel"].forEach(function (ev) {
      cmp.addEventListener(ev, function () { cmp.classList.remove("dragging"); });
    });
    cmp.setAttribute("tabindex", "0");
    cmp.setAttribute("role", "slider");
    cmp.setAttribute("aria-valuemin", "0");
    cmp.setAttribute("aria-valuemax", "100");
    cmp.setAttribute("aria-valuenow", "50");
    cmp.addEventListener("keydown", function (e) {
      var cur = parseFloat(cmp.style.getPropertyValue("--pos")) || 50;
      var next = e.key === "ArrowLeft" ? cur - 5 : e.key === "ArrowRight" ? cur + 5 : null;
      if (next !== null) { e.preventDefault(); setPos(next / 100); cmp.setAttribute("aria-valuenow", String(Math.round(next))); }
    });
    cmp.style.setProperty("--pos", "50%");
  });
  /* ================= BUNDLE SELECTOR (produkt) ================= */
  function refreshShipMsg() {
    var pn = $(".price-now");
    if (pn) {
      var b = BUNDLES[selectedBundle];
      var saving = b.old > b.price;
      pn.textContent = formatKr(b.price);
      pn.classList.remove("pop"); void pn.offsetWidth; pn.classList.add("pop");
      var po = $(".price-old");
      if (po) {
        po.style.display = saving ? "" : "none";
        if (saving) po.textContent = formatKr(b.old);
      }
      var db = $(".discount-badge");
      if (db) {
        db.style.display = saving ? "" : "none";
        if (saving) db.textContent = t("prod.bs" + b.qty + "save");
      }
    }
    var el = $(".ship-progress .ship-msg");
    if (!el) return;
    var total = BUNDLES[selectedBundle].price;
    var pct = Math.min((total / FREE_SHIP) * 100, 100);
    var bar = $(".ship-progress .ship-track i");
    if (bar) bar.style.width = pct + "%";
    if (total >= FREE_SHIP) {
      el.innerHTML = t("prod.ship.free");
    } else {
      el.innerHTML = t("prod.ship.almost").replace("{n}", String(FREE_SHIP - total));
    }
    var addBtn = $(".btn-add");
    if (addBtn && !addBtn.disabled) {
      var b2 = BUNDLES[selectedBundle];
      addBtn.innerHTML = "🛒 " + t("prod.add") + " • " + formatKr(b2.price);
    }
    var sbPrice = $(".sb-price");
    if (sbPrice) {
      var bb = BUNDLES[selectedBundle];
      sbPrice.innerHTML = "<b>" + formatKr(bb.price) + "</b>" + (bb.old > bb.price ? "<span class='old'>" + formatKr(bb.old) + "</span>" : "") + (bb.old > bb.price ? "<span class='save'>" + t("prod.bs" + bb.qty + "save") + "</span>" : "");
    }
  }
  function selectBundle(i) {
    selectedBundle = i;
    $$(".bs-opt").forEach(function (o, idx) {
      o.classList.toggle("selected", idx === i);
      o.setAttribute("aria-pressed", idx === i ? "true" : "false");
    });
    refreshShipMsg();
  }
  $$(".bs-opt").forEach(function (o, i) {
    o.addEventListener("click", function () { selectBundle(i); });
  });

  /* ================= FAQ / ACCORDIONS ================= */
  $$(".faq-q, .acc-q").forEach(function (q) {
    q.addEventListener("click", function () {
      var item = q.parentElement;
      var isFaq = item.classList.contains("faq-item");
      var wasOpen = item.classList.contains("open");
      if (isFaq) {
        $$(".faq-item.open").forEach(function (other) { other.classList.remove("open"); });
      }
      item.classList.toggle("open", !wasOpen);
    });
  });

  /* ================= GALLERY (produkt) ================= */
  var thumbs = $$(".thumb");
  var galMain = $(".gallery-main img");
  thumbs.forEach(function (th) {
    th.addEventListener("click", function () {
      thumbs.forEach(function (x) { x.classList.remove("active"); });
      th.classList.add("active");
      if (galMain) galMain.src = IMG[th.getAttribute("data-full")] || th.getAttribute("data-full");
    });
  });

  /* ================= CAROUSEL ================= */
  function initCarousel(car) {
    var viewport = $(".car-viewport", car);
    var track = $(".car-track", car);
    if (!track) return;
    var cards = $$(".rev-card", track);
    if (cards.length < 2) return;
    var index = 0, maxIndex = 0, dragging = false, startX = 0, startTx = 0, moved = 0;
    var gap = 20;

    var dotsBox = $(".car-dots", car);
    function createDots() {
      if (!dotsBox) return;
      dotsBox.innerHTML = "";
      for (var i = 0; i <= maxIndex; i++) {
        var d = document.createElement("button");
        d.className = "car-dot" + (i === 0 ? " on" : "");
        d.setAttribute("aria-label", "Go to slide " + (i + 1));
        (function (idx) { d.addEventListener("click", function () { index = idx; render(); }); })(i);
        dotsBox.appendChild(d);
      }
    }
    function measure() {
      var w = viewport.clientWidth;
      var cardW = cards[0].offsetWidth || 350;
      var visible = Math.max(1, Math.floor((w + gap) / (cardW + gap)));
      maxIndex = Math.max(0, cards.length - visible);
      if (index > maxIndex) index = maxIndex;
      createDots();
      render(true);
    }
    function render(noAnim) {
      var tx = -index * (cards[0].offsetWidth + gap);
      track.style.transition = noAnim ? "none" : "transform .6s cubic-bezier(.2,.7,.2,1)";
      track.style.transform = "translateX(" + tx + "px)";
      $$(".car-dot", car).forEach(function (d, i) { d.classList.toggle("on", i === index); });
    }
    var prev = $(".car-arrow[data-dir='-1']", car), next = $(".car-arrow[data-dir='1']", car);
    if (prev) prev.addEventListener("click", function () { index = Math.max(0, index - 1); render(); });
    if (next) next.addEventListener("click", function () { index = Math.min(maxIndex, index + 1); render(); });

    track.addEventListener("pointerdown", function (e) {
      dragging = true; startX = e.clientX; startTx = index; moved = 0;
      track.style.cursor = "grabbing";
    });
    window.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      moved = e.clientX - startX;
      if (Math.abs(moved) > 6) car.classList.add("dragging");
      var cardW = cards[0].offsetWidth + gap;
      var preview = startTx - moved / cardW;
      preview = Math.max(0, Math.min(maxIndex, preview));
      track.style.transition = "none";
      track.style.transform = "translateX(" + (-preview * cardW) + "px)";
    });
    window.addEventListener("pointerup", function () {
      if (!dragging) return;
      dragging = false;
      track.style.cursor = "";
      car.classList.remove("dragging");
      var cardW = cards[0].offsetWidth + gap;
      if (moved < -40) index = Math.min(maxIndex, index + 1);
      else if (moved > 40) index = Math.max(0, index - 1);
      render();
    });

    var timer = null;
    function play() { stop(); timer = setInterval(function () { index = index >= maxIndex ? 0 : index + 1; render(); }, 4800); }
    function stop() { if (timer) clearInterval(timer); }
    car.addEventListener("mouseenter", stop);
    car.addEventListener("mouseleave", play);

    window.addEventListener("resize", measure);
    measure();
    play();
  }
  $$(".car").forEach(initCarousel);

  /* ================= FORMS ================= */
  $$("form[data-toast]").forEach(function (f) {
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      toast(t(f.getAttribute("data-toast")), "✉");
      f.reset();
    });
  });

  /* ================= INIT ================= */
  $$("[data-img]").forEach(function (el) {
    var k = el.getAttribute("data-img");
    if (IMG[k]) el.src = IMG[k];
  });
  /* ================= HERO-POSE (uden baggrund) =================
     HERO_POUCH_URL: indsæt CDN-URL'en til pose-billedet her, når det er uploadet til Shopify.
     Scriptet fjerner automatisk den lyse baggrund, så kun posen vises — med boksene rundt om. */
  var HERO_POUCH_URL = "";
  window.floodRemoveBg = floodRemoveBg; // eksponeret så vi kan tune den i demoen
  function floodRemoveBg(img, tol) {
    tol = tol || 52;
    var w = img.naturalWidth, h = img.naturalHeight, N = w * h;
    var c = document.createElement("canvas");
    c.width = w; c.height = h;
    var ctx = c.getContext("2d");
    ctx.drawImage(img, 0, 0);
    var d = ctx.getImageData(0, 0, w, h);
    var px = d.data;
    var at = function (x, y) { return (y * w + x) * 4; };
    var step = Math.max(2, Math.round(w / 60)), br = 0, bg = 0, bb = 0, cnt = 0;
    var add = function (x, y) { var k = at(x, y); br += px[k]; bg += px[k + 1]; bb += px[k + 2]; cnt++; };
    for (var sx = 0; sx < w; sx += step) { add(sx, 2); add(sx, h - 3); }
    for (var sy = 0; sy < h; sy += step) { add(2, sy); add(w - 3, sy); }
    br = (br / cnt) | 0; bg = (bg / cnt) | 0; bb = (bb / cnt) | 0;
    var isBg = new Uint8Array(N);
    for (var i = 0; i < N; i++) { var j = i * 4;
      if (Math.max(Math.abs(px[j] - br), Math.abs(px[j + 1] - bg), Math.abs(px[j + 2] - bb)) < tol) isBg[i] = 1;
    }
    var removed = new Uint8Array(N), stack = [];
    var edge = function (x, y) { var k = y * w + x; if (isBg[k] && !removed[k]) { removed[k] = 1; stack.push(k); } };
    for (var x = 0; x < w; x++) { edge(x, 0); edge(x, h - 1); }
    for (var y = 0; y < h; y++) { edge(0, y); edge(w - 1, y); }
    while (stack.length) { var k2 = stack.pop(); var x2 = k2 % w, y2 = (k2 / w) | 0;
      if (x2 > 0 && isBg[k2 - 1] && !removed[k2 - 1]) { removed[k2 - 1] = 1; stack.push(k2 - 1); }
      if (x2 < w - 1 && isBg[k2 + 1] && !removed[k2 + 1]) { removed[k2 + 1] = 1; stack.push(k2 + 1); }
      if (y2 > 0 && isBg[k2 - w] && !removed[k2 - w]) { removed[k2 - w] = 1; stack.push(k2 - w); }
      if (y2 < h - 1 && isBg[k2 + w] && !removed[k2 + w]) { removed[k2 + w] = 1; stack.push(k2 + w); }
    }
    var alpha = new Uint8Array(N), a2 = new Uint8Array(N);
    for (var i6 = 0; i6 < N; i6++) alpha[i6] = removed[i6] ? 0 : 255;
    for (var i7 = 0; i7 < N; i7++) {
      if (removed[i7]) {
        var x7 = i7 % w, y7 = (i7 / w) | 0, s = 0, cnt2 = 0;
        for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) {
          var nx7 = x7 + dx, ny7 = y7 + dy;
          if (nx7 >= 0 && nx7 < w && ny7 >= 0 && ny7 < h) { s += alpha[ny7 * w + nx7]; cnt2++; }
        }
        a2[i7] = cnt2 ? ((s / cnt2) * 0.85) | 0 : 0;
      } else a2[i7] = 255;
    }
    for (var i8 = 0; i8 < N; i8++) px[i8 * 4 + 3] = a2[i8];
    ctx.putImageData(d, 0, 0);
    return c;
  }
  var heroImgEl = document.querySelector(".hero-img");
  if (heroImgEl && HERO_POUCH_URL) {
    var pi = new Image();
    pi.crossOrigin = "anonymous";
    pi.onload = function () {
      try {
        heroImgEl.src = floodRemoveBg(pi, 38).toDataURL("image/png");
        heroImgEl.style.maskImage = "none";
        heroImgEl.style.webkitMaskImage = "none";
      } catch (e) { heroImgEl.src = HERO_POUCH_URL; }
    };
    pi.onerror = function () { heroImgEl.src = HERO_POUCH_URL; };
    pi.src = HERO_POUCH_URL;
  }
  // marquee: mål præcis perioden (første kopi + mellemrum) for sømløst loop
  function fixMarquee() {
    var mt = $(".marquee-track");
    if (mt && mt.children.length > 8 && mt.children[8].offsetLeft > 0) {
      mt.style.setProperty("--mx", "-" + Math.round(mt.children[8].offsetLeft) + "px");
    }
  }
  fixMarquee();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fixMarquee);
  window.addEventListener("load", fixMarquee);
  window.addEventListener("resize", fixMarquee);
  // header-højde (ann + nav) → --head-h
  var siteHeader = $(".site-header");
  if (siteHeader) {
    var setHead = function () {
      document.documentElement.style.setProperty("--head-h", siteHeader.offsetHeight + "px");
    };
    setHead();
    window.addEventListener("resize", setHead);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setHead);
  }
  if (!("IntersectionObserver" in window)) {
    $$(".reveal").forEach(function (el) { el.classList.add("in"); });
  }
  /* ================= NEUTROS CLUB (MEDLEM) ================= */
  // Bemærk: login/ordrer/niveauer er simuleret i browseren (som i demoen).
  // I en rigtig butik kobles dette til en loyalitets-app (fx Smile.io/Growave)
  // og Shopifys kundekonti — se README.
  var MEMBER_KEY = "nn_member";
  var LEVELS = [
    { key: "BRONZE",   min: 0, id: "BRZ" },
    { key: "SILVER",   min: 4, id: "SLV" },
    { key: "GOLD",     min: 8, id: "GLD" },
    { key: "PLATINUM", min: 12, id: "PLT" }
  ];
  // 1 købt pose = 1 point · 4 point = næste niveau (Bronze 0-3, Sølv 4-7, Guld 8-11, Platin 12+)
  function getMember() {
    try { return JSON.parse(localStorage.getItem(MEMBER_KEY) || "null"); } catch (e) { return null; }
  }
  function setMember(m) {
    if (m) localStorage.setItem(MEMBER_KEY, JSON.stringify(m));
    else localStorage.removeItem(MEMBER_KEY);
  }
  function totalPouches(m) {
    if (!m || !m.orders) return 0;
    return m.orders.reduce(function (s, o) { return s + (o.pouches || 0); }, 0);
  }
  function levelIndex(total) {
    var i = 0;
    for (var k = 0; k < LEVELS.length; k++) if (total >= LEVELS[k].min) i = k;
    return i;
  }
  function memberId(m, li) {
    if (m.id) return m.id;
    var r = function () { return Math.floor(1000 + Math.random() * 9000); };
    m.id = LEVELS[li].id + "-" + r() + "-" + r();
    setMember(m);
    return m.id;
  }
  function lockSvg() {
    return '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="11" width="16" height="10" rx="2.5"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
  }
  function updateMemberBtn() {
    var b = $(".member-btn");
    if (b) b.classList.toggle("logged", !!getMember());
  }
  function renderClub() {
    var auth = $("#clubAuth"), dash = $("#clubDash");
    if (!auth || !dash) return;
    var m = getMember();
    auth.style.display = m ? "none" : "";
    dash.style.display = m ? "" : "none";
    if (m) renderDash(m);
    else {
      $$(".mtab").forEach(function (x) { x.classList.remove("on"); });
      var lt = $('.mtab[data-mtab="login"]'); if (lt) lt.classList.add("on");
      $("#clubLoginForm").classList.remove("hidden");
      $("#clubRegForm").classList.add("hidden");
      $$(".mform .err").forEach(function (e) { e.classList.remove("show"); });
    }
    updateMemberBtn();
    requestAnimationFrame(function () {
      $$(".reveal", $("#view-member")).forEach(function (el) {
        if (!el.classList.contains("in")) io.observe(el);
      });
    });
  }
  function renderDash(m) {
    var total = totalPouches(m);
    var li = levelIndex(total);
    var lv = LEVELS[li];
    var full = li === LEVELS.length - 1;
    var w = $("#clubFirstName");
    if (w) w.textContent = (m.first || "medlem").toUpperCase();
    var card = $("#memberCard");
    if (card) {
      card.className = "mcard mcard-" + lv.key.toLowerCase();
      var name = $("#mcName"); if (name) name.textContent = ((m.first || "") + " " + (m.last || "")).toUpperCase().trim();
      var lvl = $("#mcLevel"); if (lvl) lvl.textContent = lv.key;
      var since = $("#mcSince"); if (since) since.textContent = t("club.memberSince");
      var mid = $("#mcId"); if (mid) mid.textContent = memberId(m, li);
    }
    var pl = $("#mpLevels");
    if (pl) pl.innerHTML = full ? "<b>PLATINUM</b>" : "<b>" + lv.key + "</b> → " + LEVELS[li + 1].key;
    var size = full ? 0 : LEVELS[li + 1].min - lv.min;
    var fill = $("#mpFill");
    if (fill) fill.style.width = full ? "100%" : Math.min(100, Math.round((total - lv.min) / size * 100)) + "%";
    var mc = $("#mpCount");
    if (mc) mc.innerHTML = full ? "<b>" + lv.min + "+</b> " + t("club.pouches") : "<b>" + (total - lv.min) + " / " + size + "</b> " + t("club.pouches");
    var ms = $("#mpSub");
    if (ms) {
      if (full) ms.textContent = t("club.maxLevelSub");
      else {
        var need = lv.min + size - total;
        var txt = (need === 1 ? t("club.oneMore") : t("club.more")).replace("{n}", need).replace("{level}", LEVELS[li + 1].key);
        ms.textContent = txt;
      }
    }
    var rg = $("#rewardGrid");
    if (rg) { rg.innerHTML = rewardHTML(li); $$("[data-img]", rg).forEach(function (el) { var k = el.getAttribute("data-img"); if (IMG[k]) el.src = IMG[k]; }); }
    var jg = $("#journeyGrid");
    if (jg) jg.innerHTML = journeyHTML(li);
  }
  function rewardHTML(li) {
    var REW = [
      { t: "BRONZE", sub: t("club.rwBsub"), d: t("club.rwBd"), img: "gift" },
      { t: "SILVER", sub: t("club.rwSsub"), d: t("club.rwSd"), img: "pouch" },
      { t: "GOLD", sub: t("club.rwGsub"), d: t("club.rwGd"), img: "gift" },
      { t: "PLATINUM", sub: t("club.rwPsub"), d: t("club.rwPd"), img: "gift" }
    ];
    var html = "";
    for (var i = 0; i < REW.length; i++) {
      var r = REW[i];
      var unlocked = i <= li;
      var isNext = i === li + 1;
      var visual = r.img === "pouch"
        ? '<img data-img="pouchMain" alt="">'
        : '<div class="rv-art"><svg viewBox="0 0 48 48" width="60" height="60" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="20" width="32" height="20" rx="4"/><path d="M8 20h32"/><path d="M24 20c-3 0-8-4-8-8 0-2 1.5-3.5 3.5-3.5 3 0 4.5 4 4.5 4s1.5-4 4.5-4C30.5 8.5 32 10 32 12c0 4-5 8-8 8z"/><path d="M24 40v-20"/></svg></div>';
      html +=
        '<div class="reward-card' + (unlocked ? (i === li ? " current" : "") : " locked") + '">' +
          '<div class="reward-visual">' + visual +
            '<span class="rv-corner">' + (unlocked ? '<span class="rv-check">✓</span>' : '<span class="rv-lock">' + lockSvg() + "</span>") + "</span>" +
          "</div>" +
          '<div class="reward-body">' +
            (isNext ? '<span class="rv-next">' + t("club.nextReward") + "</span>" : "") +
            "<h3>" + r.t + "</h3>" +
            '<span class="rw-sub">' + r.sub + "</span>" +
            "<p>" + r.d + "</p>" +
          "</div>" +
        "</div>";
    }
    return html;
  }
  function journeyHTML(li) {
    var DESCS = [t("club.journeyB"), t("club.journeyS"), t("club.journeyG"), t("club.journeyP")];
    var html = "";
    for (var i = 0; i < LEVELS.length; i++) {
      var lv = LEVELS[i];
      var cls = "journey-card" + (i === li ? " current" : i < li ? " unlocked" : " locked");
      var state = i < li
        ? '<span class="jc-state open">✓ ' + t("club.journeyOpen") + "</span>"
        : i === li ? '<span class="jc-state yours">★ ' + t("club.journeyYours") + "</span>"
        : '<span class="jc-state lock">' + lockSvg() + " " + t("club.locked") + "</span>";
      html +=
        '<div class="' + cls + '">' +
          '<div class="jc-medal jc-' + lv.key.toLowerCase() + '">' + lv.key.charAt(0) + "</div>" +
          "<h3>" + lv.key + "</h3>" +
          "<p>" + DESCS[i] + "</p>" +
          state +
        "</div>";
    }
    return html;
  }
  // Tabs: log ind / opret medlem
  $$(".mtab").forEach(function (b) {
    b.addEventListener("click", function () {
      $$(".mtab").forEach(function (x) { x.classList.remove("on"); });
      b.classList.add("on");
      var mode = b.getAttribute("data-mtab");
      $("#clubLoginForm").classList.toggle("hidden", mode !== "login");
      $("#clubRegForm").classList.toggle("hidden", mode !== "register");
    });
  });
  function showErr(form, msg) {
    var e = $(".err", form);
    if (e) { e.textContent = msg; e.classList.add("show"); }
  }
  function makeMember(email, name) {
    var parts = (name || "").trim().split(/\s+/);
    var first = parts[0] || "Medlem";
    var last = parts.slice(1).join(" ");
    return { first: first, last: last, email: (email || "").toLowerCase(), since: 2026, orders: [], id: "" };
  }
  var loginForm = $("#clubLoginForm");
  if (loginForm) loginForm.addEventListener("submit", function (e) {
    e.preventDefault();
    var email = $("#clubLoginEmail").value.trim();
    var pw = $("#clubLoginPw").value;
    if (!email || !pw) { showErr(this, t("club.errFill")); return; }
    var existing = getMember();
    var m = existing && existing.email === email.toLowerCase() ? existing : makeMember(email, "");
    setMember(m);
    renderClub();
  });
  var regForm = $("#clubRegForm");
  if (regForm) regForm.addEventListener("submit", function (e) {
    e.preventDefault();
    var f = $("#clubRegFirst").value.trim();
    var l = $("#clubRegLast").value.trim();
    var email = $("#clubRegEmail").value.trim();
    var pw = $("#clubRegPw").value;
    if (!f || !l || !email || !pw) { showErr(this, t("club.errFill")); return; }
    if (!$("#clubRegTerms").checked) { showErr(this, t("club.errTerms")); return; }
    setMember(makeMember(email, f + " " + l));
    renderClub();
  });
  $$("[data-demo-login]").forEach(function (b) {
    b.addEventListener("click", function () {
      setMember({ first: "Jacob", last: "Mählmann", email: "jacob@demo.dk", since: 2026,
        orders: [ { pouches: 1, date: "2026-06-14" }, { pouches: 1, date: "2026-07-02" } ], id: "BRZ-9847-2216" });
      renderClub();
      renderAccount();
    });
  });
  var memberBtn = $(".member-btn");
  if (memberBtn) memberBtn.addEventListener("click", function () { location.hash = "#/medlem"; });
  $$("[data-logout]").forEach(function (b) {
    b.addEventListener("click", function () {
      setMember(null);
      renderClub();
      toast(t("club.loggedOut"), "👋");
    });
  });
  $$(".ov-card[data-goto]").forEach(function (c) {
    c.addEventListener("click", function () {
      var g = c.getAttribute("data-goto");
      if (g === "rewards") smoothScrollToEl(document.getElementById("rewards"));
      else if (g === "top") smoothScrollTo(0);
      else toast(t("toast.soon"), "🔒");
    });
  });
  var mcardEl = $("#memberCard");
  if (mcardEl && window.matchMedia && window.matchMedia("(pointer:fine)").matches) {
    mcardEl.addEventListener("mousemove", function (e) {
      var r = mcardEl.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      mcardEl.style.transform = "perspective(900px) rotateY(" + (px * 9).toFixed(2) + "deg) rotateX(" + (-py * 9).toFixed(2) + "deg)";
    });
    mcardEl.addEventListener("mouseleave", function () { mcardEl.style.transform = ""; });
  }
  // Blomster: langsom, elegant parallax — de toner ind, så snart de kommer ind på skærmen
  function clubFlowers() {
    var view = $("#view-member");
    if (!view || !view.classList.contains("active")) return;
    var vh = window.innerHeight || 800;
    $$(".mf", view).forEach(function (f) {
      var r = f.getBoundingClientRect();
      if (!r.height) { f.style.opacity = "0"; return; }
      var center = r.top + r.height / 2;
      // 0 lige under skærmen → 1 ved ~40 % ned på skærmen (altid synlig, aldrig scrollet forbi)
      var p = Math.min(Math.max((vh + 60 - center) / (vh * 0.6 + 60), 0), 1);
      var ease = 1 - Math.pow(1 - p, 3);
      var dir = f.getAttribute("data-dir") === "r" ? 1 : -1;
      var fy = parseFloat(f.getAttribute("data-fy")) || 0;
      var fr = parseFloat(f.getAttribute("data-fr")) || 0;
      f.style.opacity = String(ease * 0.92);
      f.style.transform = "translateX(" + (dir * (1 - ease) * 90).toFixed(1) + "px) translateY(" + (-ease * 34 * fy).toFixed(1) + "px) rotate(" + (ease * fr).toFixed(1) + "deg)";
    });
  }

  /* ================= KONTO-SIDER (burgermenu) ================= */
  function esc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function fmtDate(s) {
    if (!s) return "";
    var d = new Date(s + "T00:00:00");
    if (isNaN(d.getTime())) return s;
    return d.toLocaleDateString(lang === "da" ? "da-DK" : "en-US", { day: "numeric", month: "long", year: "numeric" });
  }
  function getAddresses() { try { return JSON.parse(localStorage.getItem("nn_addresses") || "null"); } catch (e) { return null; } }
  function setAddresses(list) { localStorage.setItem("nn_addresses", JSON.stringify(list)); }
  function defaultAddresses() {
    return [
      { tag: "ship", first: "Jacob", last: "Mählmann", street: "Jerndorffsvænget 11", zip: "7000", city: "Fredericia", country: "Danmark", def: true },
      { tag: "bill", first: "Jacob", last: "Mählmann", street: "Jerndorffsvænget 11", zip: "7000", city: "Fredericia", country: "Danmark", def: false }
    ];
  }
  function getFavs() { try { return JSON.parse(localStorage.getItem("nn_favs") || "null"); } catch (e) { return null; } }
  function setFavs(list) { localStorage.setItem("nn_favs", JSON.stringify(list)); }
  function setGate(prefix, loggedIn) {
    var out = $("#" + prefix + "Out"), inn = $("#" + prefix + "In");
    if (out) out.style.display = loggedIn ? "none" : "";
    if (inn) inn.style.display = loggedIn ? "" : "none";
  }
  function renderAccount() {
    var m = getMember();
    var hash = location.hash;
    if (hash === "#/ordrehistorik") {
      setGate("orders", !!m);
      renderOrders(m);
    } else if (hash === "#/profil") {
      setGate("profile", !!m);
      renderProfile(m);
    } else if (hash === "#/adresser") {
      setGate("addr", !!m);
      if (m) renderAddresses();
    } else if (hash === "#/favoritter") {
      renderFavs();
    }
  }
  function renderOrders(m) {
    var list = $("#ordersList");
    if (!list) return;
    if (!m) { list.innerHTML = ""; return; }
    var orders = m.orders || [];
    if (!orders.length) {
      list.innerHTML = '<div class="login-prompt"><div class="lp-ic">🛒</div><h2>' + t("orders.emptyT") + '</h2><p>' + t("orders.emptyD") + '</p><a class="btn btn-primary" href="#/produkt">' + t("orders.emptyCta") + "</a></div>";
      return;
    }
    var n = orders.length;
    var STATUS = [["st-delivered", t("orders.stDelivered")], ["st-shipped", t("orders.stShipped")], ["st-pending", t("orders.stPending")]];
    var html = "";
    orders.slice().reverse().forEach(function (o, i) {
      var si = Math.max(0, Math.min(2, n - 1 - i));
      var st = STATUS[si];
      var price = o.pouches === 2 ? BUNDLES[1].price : o.pouches === 3 ? BUNDLES[2].price : BUNDLES[0].price;
      var dots = "";
      for (var d = 0; d < 3; d++) dots += "<i" + (d <= si ? ' class="done"' : "") + "></i>";
      html +=
        '<div class="order-card reveal">' +
          '<div class="oc-top"><span class="oc-no">' + t("orders.no") + " #NN-" + (1041 + n - i) + '<small>' + t("orders.date") + ": " + fmtDate(o.date) + "</small></span>" +
          '<span class="status-badge ' + st[0] + '">' + st[1] + "</span></div>" +
          '<div class="oc-mid"><div class="oc-item"><img src="' + IMG.pouchMain + '" alt=""><span><b>' + o.pouches + " × " + t("orders.pouch") + '</b><span>' + t("orders.qty") + "</span></span></div>" +
          '<div class="oc-total"><span>' + t("orders.total") + "</span><b>" + formatKr(price) + "</b></div></div>" +
          '<div class="oc-foot"><span class="oc-progress">' + dots + "</span>" +
          '<button class="btn btn-ghost btn-sm" data-order-track>' + t("orders.track") + "</button></div>" +
        "</div>";
    });
    list.innerHTML = html;
    requestAnimationFrame(function () { $$(".reveal", list).forEach(function (el) { if (!el.classList.contains("in")) io.observe(el); }); });
  }
  function renderProfile(m) {
    var f = $("#pfFirst"), l = $("#pfLast"), e = $("#pfEmail");
    if (!m) return;
    if (f) f.value = m.first || "";
    if (l) l.value = m.last || "";
    if (e) e.value = m.email || "";
  }
  function renderAddresses() {
    var grid = $("#addrGrid");
    if (!grid) return;
    var list = getAddresses();
    if (!list) { list = defaultAddresses(); setAddresses(list); }
    if (!list.length) {
      grid.innerHTML = '<div class="login-prompt" style="grid-column:1/-1"><div class="lp-ic">📍</div><h2>' + t("addr.emptyT") + "</h2></div>";
      return;
    }
    grid.innerHTML = list.map(function (a, i) {
      return '<div class="addr-card reveal">' +
        '<span class="addr-tag">' + t(a.tag === "bill" ? "addr.bill" : "addr.ship") + (a.def ? '<span class="default-badge">' + t("addr.default") + "</span>" : "") + "</span>" +
        "<h3>" + esc(a.first) + " " + esc(a.last) + "</h3>" +
        "<p>" + esc(a.street) + "<br>" + esc(a.zip) + " " + esc(a.city) + "<br>" + esc(a.country) + "</p>" +
        '<div class="addr-actions"><button data-addr-edit="' + i + '">' + t("addr.edit") + '</button><button class="danger" data-addr-rm="' + i + '">' + t("addr.remove") + "</button></div>" +
        "</div>";
    }).join("");
    requestAnimationFrame(function () { $$(".reveal", grid).forEach(function (el) { if (!el.classList.contains("in")) io.observe(el); }); });
  }
  function renderFavs() {
    var grid = $("#favGrid"), empty = $("#favEmpty");
    if (!grid) return;
    var favs = getFavs();
    if (favs === null) { favs = [{ img: "pouchMain", name: "" }]; setFavs(favs); }
    if (!favs.length) {
      grid.style.display = "none";
      grid.innerHTML = "";
      if (empty) empty.style.display = "";
      return;
    }
    grid.style.display = "";
    if (empty) empty.style.display = "none";
    grid.innerHTML = favs.map(function (f, i) {
      return '<div class="fav-card reveal">' +
        '<div class="fav-img"><img src="' + (IMG[f.img] || IMG.pouchMain) + '" alt=""><button class="fav-rm" data-fav-rm="' + i + '" aria-label="' + t("addr.remove") + '">✕</button></div>' +
        '<div class="fav-body"><span class="f-tag">' + t("fav.tag") + '</span><h3>' + (f.name || t("prod.title")) + '</h3><p>' + t("fav.desc") + "</p>" +
        '<div class="fav-foot"><span class="fav-price"><b>' + formatKr(BUNDLES[0].price) + '</b><span class="old">' + formatKr(BUNDLES[0].old) + '</span></span>' +
        '<button class="btn btn-primary btn-sm" data-fav-add="' + i + '">' + t("fav.add") + "</button></div></div></div>";
    }).join("");
    requestAnimationFrame(function () { $$(".reveal", grid).forEach(function (el) { if (!el.classList.contains("in")) io.observe(el); }); });
  }
  var addrAddBtn = $("#addrAddBtn");
  if (addrAddBtn) addrAddBtn.addEventListener("click", function () {
    var f = $("#addrForm");
    if (f) f.style.display = f.style.display === "none" ? "" : "none";
  });
  var addrForm = $("#addrForm");
  if (addrForm) addrForm.addEventListener("submit", function (e) {
    e.preventDefault();
    var first = $("#adFirst").value.trim(), last = $("#adLast").value.trim(),
        street = $("#adStreet").value.trim(), zip = $("#adZip").value.trim(),
        city = $("#adCity").value.trim(), country = $("#adCountry").value.trim();
    if (!first || !last || !street || !zip || !city) { toast(t("club.errFill"), "⚠"); return; }
    var list = getAddresses() || [];
    list.push({ tag: "ship", first: first, last: last, street: street, zip: zip, city: city, country: country, def: false });
    setAddresses(list);
    renderAddresses();
    this.style.display = "none";
    this.reset();
    toast(t("addr.saved"), "✓");
  });
  document.addEventListener("click", function (e) {
    var ot = e.target.closest("[data-order-track]");
    if (ot) { toast(t("orders.sh2d"), "📦"); return; }
    var ae = e.target.closest("[data-addr-edit]");
    if (ae) {
      var listE = getAddresses() || [];
      var a = listE[parseInt(ae.getAttribute("data-addr-edit"), 10)];
      if (a) {
        var fE = $("#addrForm");
        if ($("#adFirst")) $("#adFirst").value = a.first || "";
        if ($("#adLast")) $("#adLast").value = a.last || "";
        if ($("#adStreet")) $("#adStreet").value = a.street || "";
        if ($("#adZip")) $("#adZip").value = a.zip || "";
        if ($("#adCity")) $("#adCity").value = a.city || "";
        if ($("#adCountry")) $("#adCountry").value = a.country || "Danmark";
        if (fE) { fE.style.display = ""; smoothScrollToEl(fE); }
      }
      return;
    }
    var ar = e.target.closest("[data-addr-rm]");
    if (ar) {
      var listR = getAddresses() || [];
      listR.splice(parseInt(ar.getAttribute("data-addr-rm"), 10), 1);
      setAddresses(listR);
      renderAddresses();
      toast(t("addr.removed"), "🗑");
      return;
    }
    var rm = e.target.closest("[data-fav-rm]");
    if (rm) {
      var favs = getFavs() || [];
      favs.splice(parseInt(rm.getAttribute("data-fav-rm"), 10), 1);
      setFavs(favs);
      renderFavs();
      toast(t("fav.removed"), "🤍");
      return;
    }
    var add = e.target.closest("[data-fav-add]");
    if (add) {
      // Favoritknap → læg 1 pose i kurven
      selectedBundle = 0;
      addToCart(BUNDLES[0].price, t("prod.bs1q"));
      return;
    }
  });

  /* ================= COOKIE-SAMTYKKE (GDPR / cookiebekendtgørelsen) ================= */
  var COOKIE_KEY = "nn_cookie_consent";
  var cookiebar = $("#cookiebar");
  function getConsent() {
    try { return JSON.parse(localStorage.getItem(COOKIE_KEY) || "null"); } catch (e) { return null; }
  }
  function setConsent(c) { localStorage.setItem(COOKIE_KEY, JSON.stringify(c)); }
  function showCookiebar() {
    if (!cookiebar || cookiebar.classList.contains("show")) return;
    cookiebar.classList.add("show");
    cookiebar.setAttribute("aria-hidden", "false");
  }
  function hideCookiebar() {
    if (!cookiebar) return;
    cookiebar.classList.remove("show");
    cookiebar.classList.remove("settings");
    cookiebar.setAttribute("aria-hidden", "true");
  }
  function saveConsent(prefs, withToast) {
    setConsent(prefs);
    hideCookiebar();
    if (withToast) toast(t("cb.saved"), "✓");
  }
  // Vis banneret ved første besøg
  if (!getConsent()) {
    setTimeout(showCookiebar, 1000);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (!getConsent()) showCookiebar(); });
  }
  // Toggles i indstillingspanelet
  $$("[data-cb-cat]").forEach(function (sw) {
    sw.addEventListener("click", function () {
      if (sw.getAttribute("data-cb-cat") === "necessary") return;
      sw.classList.toggle("on");
      sw.setAttribute("aria-pressed", sw.classList.contains("on") ? "true" : "false");
    });
  });
  document.addEventListener("click", function (e) {
    var cbOpen = e.target.closest("[data-cb-open]");
    if (cbOpen) {
      // "Skift dine cookie-indstillinger" på cookiepolitikken → åbn banneret igen
      localStorage.removeItem(COOKIE_KEY);
      if (cookiebar) cookiebar.classList.remove("settings");
      showCookiebar();
      return;
    }
    var cbb = e.target.closest("[data-cb]");
    if (!cbb) return;
    var act = cbb.getAttribute("data-cb");
    if (act === "all") saveConsent({ necessary: true, statistics: true, marketing: true, date: new Date().toISOString() });
    else if (act === "necessary") saveConsent({ necessary: true, statistics: false, marketing: false, date: new Date().toISOString() });
    else if (act === "settings") { if (cookiebar) cookiebar.classList.toggle("settings"); }
    else if (act === "save") {
      var st = cookiebar && cookiebar.querySelector('[data-cb-cat="statistics"]') ? cookiebar.querySelector('[data-cb-cat="statistics"]').classList.contains("on") : false;
      var mk = cookiebar && cookiebar.querySelector('[data-cb-cat="marketing"]') ? cookiebar.querySelector('[data-cb-cat="marketing"]').classList.contains("on") : false;
      saveConsent({ necessary: true, statistics: st, marketing: mk, date: new Date().toISOString() }, true);
    }
  });

  /* ================= INGREDIENSER: swipe-karrusel (kun mobil) ================= */
  function initIngCarousel() {
    var grid = document.querySelector(".ing-grid");
    if (!grid) return;
    var cards = grid.querySelectorAll(".ing-card");
    if (!cards.length) return;
    var mq = window.matchMedia("(max-width: 640px)");
    var timer = null, idx = 0;
    var wrap = document.createElement("div");
    wrap.className = "ing-dots";
    cards.forEach(function (_, i) {
      var d = document.createElement("button");
      d.className = "ing-dot" + (i ? "" : " on");
      d.setAttribute("aria-label", "Ingrediens " + (i + 1));
      d.addEventListener("click", function () { go(i); restart(); });
      wrap.appendChild(d);
    });
    grid.parentNode.insertBefore(wrap, grid.nextSibling);
    var dots = wrap.querySelectorAll(".ing-dot");
    function go(i) {
      var n = cards.length;
      i = ((i % n) + n) % n;
      idx = i;
      var card = cards[i];
      var left = card.offsetLeft - (grid.clientWidth - card.offsetWidth) / 2;
      grid.scrollTo({ left: Math.max(0, left), behavior: "smooth" });
      dots.forEach(function (d, k) { d.classList.toggle("on", k === i); });
    }
    function start() { if (!mq.matches || timer) return; timer = setInterval(function () { go(idx + 1); }, 3200); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); if (mq.matches) timer = setInterval(function () { go(idx + 1); }, 4400); }
    var scrollT;
    grid.addEventListener("scroll", function () {
      clearTimeout(scrollT);
      scrollT = setTimeout(function () {
        var center = grid.scrollLeft + grid.clientWidth / 2;
        var best = 0, bd = Infinity;
        cards.forEach(function (el, i) {
          var d = Math.abs((el.offsetLeft + el.offsetWidth / 2) - center);
          if (d < bd) { bd = d; best = i; }
        });
        idx = best;
        dots.forEach(function (d, k) { d.classList.toggle("on", k === best); });
      }, 90);
    });
    grid.addEventListener("touchstart", stop, { passive: true });
    grid.addEventListener("touchend", function () { restart(); }, { passive: true });
    function onMq() {
      if (mq.matches) { go(0); start(); }
      else { stop(); grid.scrollTo({ left: 0, behavior: "auto" }); }
    }
    if (mq.addEventListener) mq.addEventListener("change", onMq); else if (mq.addListener) mq.addListener(onMq);
    if (mq.matches) start();
  }

  /* ================= START ================= */
  // Seed-hash fra skabelonen (fx /products/neutros → #/produkt)
  if (window.NEUTROS_SEED && !location.hash) {
    try { history.replaceState(null, "", location.pathname + location.search + window.NEUTROS_SEED); } catch (e) {}
  }
  applyLang();
  route();
  selectBundle(selectedBundle);
  refreshShipMsg();
  initIngCarousel();
  loadCart(function () {
    if (window.NEUTROS_OPEN_CART) setTimeout(openCart, 350);
  });
  loadProduct();
  updateCart();
})();
